import { render } from "./CrossPromotionView.vue?vue&type=template&id=a540b356&scoped=true"
import script from "./CrossPromotionView.vue?vue&type=script&lang=js"
export * from "./CrossPromotionView.vue?vue&type=script&lang=js"

import "./CrossPromotionView.vue?vue&type=style&index=0&id=a540b356&lang=scss&scoped=true"

import exportComponent from "/var/vsts_agent/_work/1505/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a540b356"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QTimeline from 'quasar/src/components/timeline/QTimeline.js';
import QTimelineEntry from 'quasar/src/components/timeline/QTimelineEntry.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QSpinner,QCardSection,QTabs,QTab,QSeparator,QInput,QToggle,QBtn,QDate,QPopupProxy,QSkeleton,QTimeline,QTimelineEntry,QTooltip,QDialog,QCardActions});qInstall(script, 'directives', {ClosePopup});
